module.exports = __webpack_public_path__ + "static/media/tennis.0ef365c5.mp4";